import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";


export const os_stats = [
    { value: "AVAI", label: "AVAI - Available stock" },
    { value: "BOS", label: "BOS - B/O Out of Stock" },
    { value: "BNYP", label: "BNYP - B/O Not Yet Pub" },
    { value: "BRP", label: "BRP - B/O Reprinting" },
    { value: "BITO", label: "BITO - B/O Import To Order" },
    { value: "COS", label: "COS - Cancel O/S" },
    { value: "CNYP", label: "CNYP - Cancel Not Yet Pub" },
    { value: "CNOP", label: "CNOP - Cancel Not Our Pub" },
    { value: "CNR", label: "CNR - Cancel No Rights" },
    { value: "COP", label: "COP - Cancel Out of Print" },
    { value: "CNL", label: "CNL - Cancel No Listing" },
    { value: "CNW", label: "CNW - Cancel No word" },
    { value: "COSI", label: "COSI - Cancel O/S Indef." },
    { value: "CPXL", label: "CPXL - Cancel Publication" },
    { value: "CRP", label: "CRP - Cancel Reprinting." },
    { value: "CITO", label: "CITO - Cancel Imp to Order" },
    { value: "CBU", label: "CBU - Cancel By Us" },
    { value: "CBC", label: "CBC - Cancel By Cust" }
]

export default function OSStats(props) {

    const { controller = "", callback = () => { }, value = "", route = "" } = props;
    const [selected, setSelected] = useState(os_stats.find(item => item.value === value)?.value || "AVAI");

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected) } }
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])


    const menu = os_stats.map(item => {
        let _i = { ...item };
        _i.text = _i.label;
        _i.action = () => callback(_i.value);
        return _i;
    })

    // return(<>{JSON.stringify(menu, null, 2)}</>)



    return (<><Popup title={"Status Codes"} width={"auto"} callback={callback} component={<Menu controller={controller} keyName="value" route={route} menu={menu} selected={selected} setSelected={setSelected} callback={(e) => callback(e.value)} />} /></>)
}